"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = require("redux");
var _formWrapper = _interopRequireDefault(require("./reducers/formWrapper.js"));
var _fixedSession = _interopRequireDefault(require("./reducers/fixedSession.js"));
var _reportWrapper = _interopRequireDefault(require("./reducers/reportWrapper.js"));
var _gui = _interopRequireDefault(require("./reducers/gui.js"));
var _appDefsObject = _interopRequireDefault(require("./reducers/appDefsObject.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = (0, _redux.combineReducers)({
  formWrapper: _formWrapper["default"],
  fixedSession: _fixedSession["default"],
  reportWrapper: _reportWrapper["default"],
  gui: _gui["default"],
  appDefsObject: _appDefsObject["default"]
});